import React, { useEffect, useState } from 'react';
import { useApp } from '../../context/AppContext';

const TrackingScripts = () => {
  const { settings, loading } = useApp();
  const [consentGranted, setConsentGranted] = useState(
    localStorage.getItem('gdpr_consent') === 'accepted'
  );
  
  // Posluchač pro custom event z CookieBanner.js
  useEffect(() => {
    const handleConsentUpdate = () => {
      setConsentGranted(localStorage.getItem('gdpr_consent') === 'accepted');
    };

    window.addEventListener('cookie-consent-updated', handleConsentUpdate);
    return () => window.removeEventListener('cookie-consent-updated', handleConsentUpdate);
  }, []);

  // Inicializace skriptů (proběhne po načtení settings)
  useEffect(() => {
    if (loading || !settings) return;

    // GA4 a GTM potřebují dataLayer
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }

    const initTracking = () => {
      // ===== Google Analytics 4 =====
      // Podpora výchozího tagu z textu nebo z databáze
      const gaIds = [];
      if (settings.ga_measurement_id) {
        // Může to být seznam oddělený čárkou
        gaIds.push(...settings.ga_measurement_id.split(',').map(id => id.trim()));
      }

      if (gaIds.length > 0 && !window.gaInitialized) {
        // Nastavit základní consent state (denied před povolením)
        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied'
        });

        // Vložit skript
        const gaScript = document.createElement('script');
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaIds[0]}`;
        gaScript.async = true;
        document.head.appendChild(gaScript);

        // Inicializovat GA
        gtag('js', new Date());
        gaIds.forEach(id => {
          gtag('config', id);
        });
        
        window.gaInitialized = true;
      }

      // ===== Meta Pixel =====
      if (settings.fb_pixel_id && !window.fbInitialized) {
        /* eslint-disable-next-line no-unused-expressions */
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        
        window.fbq('consent', 'revoke'); // Výchozí stav bez souhlasu
        window.fbq('init', settings.fb_pixel_id);
        window.fbq('track', 'PageView');
        window.fbInitialized = true;
      }

      // ===== Microsoft Clarity =====
      if (settings.ms_clarity_id && !window.clarityInitialized) {
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", settings.ms_clarity_id);
        
        // Clarity má Consent API od verze 1.0 (requires window.clarity('consent'))
        window.clarityInitialized = true;
      }

      // ===== Vlastní Head a Body skripty =====
      if (settings.custom_head_scripts && !window.headScriptsAdded) {
        try {
          const div = document.createElement('div');
          div.innerHTML = settings.custom_head_scripts;
          Array.from(div.children).forEach(child => {
            if (child.tagName === 'SCRIPT') {
              const newScript = document.createElement('script');
              Array.from(child.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
              newScript.innerHTML = child.innerHTML;
              document.head.appendChild(newScript);
            } else {
              document.head.appendChild(child);
            }
          });
          window.headScriptsAdded = true;
        } catch (e) {
          console.error("Error parsing custom_head_scripts", e);
        }
      }
    };

    initTracking();

  }, [settings, loading]);

  // Aplikace Consent Mode na základě uděleného souhlasu
  useEffect(() => {
    function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
    
    // Cookie souhlas byl aktualizován (uživatel povolil cookies)
    if (consentGranted) {
      // 1. Google Analytics Update
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
      });

      // 2. Meta Pixel Grant
      if (window.fbq) {
        window.fbq('consent', 'grant');
      }

      // 3. Microsoft Clarity Consent
      if (window.clarity) {
        window.clarity('consent');
      }
    }
  }, [consentGranted]);

  return null; // Tato komponenta je neviditelná
};

export default TrackingScripts;
